























































































import { Component, Vue } from 'vue-property-decorator';
import investmentPageApi from '@/api/investmentPage';

@Component({
  components: {
  },
})

export default class InvestmentPagePc extends Vue {
  poiAddressParams = {
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    districtCode: '',
    districtName: '',
  }

  formCustom = {
    name: '',
    phone: '',
    poiAddress: [],
  }

  areaList: Array<Object> = []

  submitting: Boolean = false

  isLeaveElectricity: Boolean = false

  namecolor: Boolean = false

  phonecolor: Boolean = false

  poiAddress: Boolean = false

  falsePhone: Boolean = false

  disabled: Boolean = false

  ruleCustom = {
    name: [{ required: true, message: '请输入您的姓名' }, { validator: this.checkname, trigger: 'blur' }],
    phone: [{ required: true, message: '请输入您的手机号' }, { validator: this.checkphone, trigger: 'blur' }],
    poiAddress: [{ required: true, message: '请选择您门店的所在城市' }, { validator: this.checkpoiAddress, trigger: 'blur' }],
  }

  checkname(rule: any, value: any, callback: any) {
    if (!value) {
      this.namecolor = true;
      callback();
    } else {
      this.namecolor = false;
      callback();
    }
  }

  checkphone(rule: any, value: any, callback: any) {
    if (!/^1\d{10}$/.test(value)) {
      this.phonecolor = true;
      this.falsePhone = true;
      callback(new Error());
    } else {
      this.phonecolor = false;
      this.falsePhone = false;
      callback();
    }
  }

  checkpoiAddress(rule: any, value: any, callback: any) {
    if (JSON.stringify(value) === '[]') {
      this.poiAddress = true;
      callback(new Error());
    } else {
      this.poiAddress = false;
      callback();
    }
  }

  async mounted() {
    await this.getAreaList();
  }

  get channelType(): number { // 1 到综 2？
    const { channelType = 1 } = this.$route.query;
    return Number(channelType);
  }

  async getAreaList() {
    const { error, data }: ApiResponse.MDPData = await investmentPageApi.getAreaList();
    if (!error && data && data.list) {
      data.list.forEach((item1: any) => {
        item1.children.splice(0, 1);
        item1.children.forEach((item2: any) => {
          item2.children.splice(0, 1);
        });
      });
      this.areaList = data.list;
    }
  }

  async onSubmit() {
    (this.$refs.formCustom as any).validate(async (valid: any) => {
      if (valid) {
        if (this.submitting) return;
        this.submitting = true;
        this.disabled = true;
        await this.onSave();
        this.submitting = false;
        this.disabled = false;
      } else {
        this.$mtd.message.error('请填写全部信息');
      }
    });
  }

  async onSave() {
    const params = {
      name: this.formCustom.name,
      phone: this.formCustom.phone,
      channelType: this.channelType,
      resourceEntrance: 2, // 1-APP 2-PC 3-其他
      ...this.poiAddressParams,
    };
    const { error, data }: ApiResponse.MDPData = await investmentPageApi.onSave(params);
    if (!error && data) {
      this.isLeaveElectricity = true;
    }
  }

  handleChange(value: any, selectOptons: any) {
    this.poiAddressParams = {
      provinceCode: selectOptons[0].code,
      provinceName: selectOptons[0].name,
      cityCode: selectOptons[1].code,
      cityName: selectOptons[1].name,
      districtCode: selectOptons[2].code,
      districtName: selectOptons[2].name,
    };
  }

  phoneChange() {
    this.falsePhone = false;
  }
}
